import React, { FC, PropsWithChildren } from 'react';
import './AdminTableOverlap.scss';

export const AdminTableOverlap: FC<PropsWithChildren> = ({ children }) => {
  return <div className="AdminTableOverlap">{children}</div>;
};
